(function () {
  function getParam(name) {
    var m = new RegExp('[?&]' + name + '=([^&]+)').exec(window.location.search);
    return m ? m[1] : null;
  }
  function decodePayload(raw) {
    if (!raw) return null;
    try {
      var json = decodeURIComponent(escape(atob(decodeURIComponent(raw))));
      return JSON.parse(json);
    } catch (e) {}
    try {
      return JSON.parse(decodeURIComponent(raw));
    } catch (e2) {}
    return null;
  }
  var payload = decodePayload(getParam('sinners_edit'));
  if (!payload) return; // nem szerkesztés -> nem csinálunk semmit
  var oldKeys = [];
  if (payload.a && payload.a.key) oldKeys.push(payload.a.key);
  if (payload.b && payload.b.key) oldKeys.push(payload.b.key);
  function parseStored(text) {
    if (!text) return null;
    var res = { code: '', ab: '', custom: '' };
    var mCode = /^\s*(\d{1,2})\b/.exec(text);
    if (mCode) res.code = mCode[1];
    var mAB = /ezen a pulcsin:\s*([AB])\s*verzió/i.exec(text);
    if (mAB) res.ab = mAB[1].toUpperCase();
    if (res.code === '39' || res.code === '42' || res.code === '43') {
      var base = text.split(' | ')[0];
      var idx = base.indexOf(': ');
      if (idx !== -1) res.custom = base.slice(idx + 2).trim();
    }
    return res;
  }
  var PLACE_KEYS = {
    a: {
      front: 'Eleje nyakkör középen - A (kód)',
      back:  'Háta nyakkör kapucni alatt - A (kód)',
      cuff:  'Kézelő felett - A (kód)'
    },
    b: {
      front: 'Eleje nyakkör középen - B (kód)',
      back:  'Háta nyakkör kapucni alatt - B (kód)',
      cuff:  'Kézelő felett - B (kód)'
    }
  };
  var CUSTOM_KEYS = {
    a: { front: 'Egyedi szöveg - A - Eleje', back: 'Egyedi szöveg - A - Hát', cuff: 'Egyedi szöveg - A - Kézelő' },
    b: { front: 'Egyedi szöveg - B - Eleje', back: 'Egyedi szöveg - B - Hát', cuff: 'Egyedi szöveg - B - Kézelő' }
  };
  function setSelectValue(sel, value) {
    if (!sel) return false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === String(value)) { sel.value = String(value); return true; }
    }
    return false;
  }
  function fireChange(el) {
    if (!el) return;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function prefillGroup(group, data) {
    if (!data) return;
    var variantSel = document.querySelector('.bundle-variant[data-role="variant-' + group + '"]');
    if (variantSel && data.variantId) setSelectValue(variantSel, data.variantId);
    var props = data.props || {};
    ['front', 'back', 'cuff'].forEach(function (place) {
      var storedKey = PLACE_KEYS[group][place];
      var stored = props[storedKey];
      var parsed = parseStored(stored);
      if (!parsed || !parsed.code) return;
      var codeSel = document.querySelector('.bundle-code-select[data-group="' + group + '"][data-place="' + place + '"]');
      if (codeSel) {
        setSelectValue(codeSel, parsed.code);
        fireChange(codeSel); // ez megnyitja az A/B vagy egyedi mezőt a bundle logikájával
      }
      if (parsed.ab) {
        var abSel = document.querySelector('.bundle-ab-select[data-group="' + group + '"][data-place="' + place + '"]');
        if (abSel) { setSelectValue(abSel, parsed.ab); fireChange(abSel); }
      }
      if (parsed.custom) {
        var wrap = document.querySelector('.bundle-custom-text[data-group="' + group + '"][data-place="' + place + '"]');
        var input = wrap ? wrap.querySelector('input') : null;
        if (input) input.value = parsed.custom;
      }
    });
  }
  function prefillNote() {
    var note = null;
    if (payload.a && payload.a.props && payload.a.props['Megjegyzés a páros hoodie-hoz']) {
      note = payload.a.props['Megjegyzés a páros hoodie-hoz'];
    } else if (payload.b && payload.b.props && payload.b.props['Megjegyzés a páros hoodie-hoz']) {
      note = payload.b.props['Megjegyzés a páros hoodie-hoz'];
    }
    if (note) {
      var noteEl = document.querySelector('[data-bundle-note]');
      if (noteEl) noteEl.value = note;
    }
  }
  function hookReplaceOnAdd() {
    if (!oldKeys.length) return;
    var btn = document.getElementById('bundle-add-to-cart');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // ne fusson a bundle saját add-kezelője
      var selectA = document.querySelector('[data-role="variant-a"]');
      var selectB = document.querySelector('[data-role="variant-b"]');
      if (!selectA || !selectB || !selectA.value || !selectB.value) {
        alert('Válaszd ki mindkét pulcsi méretét!');
        return;
      }
      var noteInput = document.querySelector('[data-bundle-note]');
      var note = (noteInput && noteInput.value.trim() !== '') ? noteInput.value.trim() : null;
      var propsA = Object.assign({ 'Pár hoodie': 'Pulcsi A' }, collectProps('a'));
      var propsB = Object.assign({ 'Pár hoodie': 'Pulcsi B' }, collectProps('b'));
      if (note) {
        propsA['Megjegyzés a páros hoodie-hoz'] = note;
        propsB['Megjegyzés a páros hoodie-hoz'] = note;
      }
      var items = [
        { id: parseInt(selectA.value, 10), quantity: 1, properties: propsA },
        { id: parseInt(selectB.value, 10), quantity: 1, properties: propsB }
      ];
      if (btn) { btn.disabled = true; btn.textContent = 'Frissítés...'; }
      removeOldLines()
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) { return r.json(); });
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error(err);
          if (btn) { btn.disabled = false; btn.textContent = 'Páros hoodie a kosárba'; }
          alert('Hoppá, valami hiba történt a frissítésnél. Próbáld újra.');
        });
    }, true); // <-- capture fázis: a bundle listenere ELŐTT futunk
  }
  function collectProps(group) {
    var props = {};
    ['front', 'back', 'cuff'].forEach(function (place) {
      var codeSel = document.querySelector('.bundle-code-select[data-group="' + group + '"][data-place="' + place + '"]');
      var abSel = document.querySelector('.bundle-ab-select[data-group="' + group + '"][data-place="' + place + '"]');
      if (!codeSel) return;
      var code = codeSel.value;
      if (!code) return;
      var baseName = codeSel.getAttribute('name') || place;
      var mainText = (codeSel.options && codeSel.options[codeSel.selectedIndex])
        ? codeSel.options[codeSel.selectedIndex].text
        : code;
      var num = parseInt(code, 10);
      var hasAB = !isNaN(num) && num >= 1 && num <= 24;
      var ab = abSel ? abSel.value : 'A';
      var versionText = (ab === 'A') ? 'A verzió' : 'B verzió';
      props[baseName] = mainText + (hasAB ? (' | ezen a pulcsin: ' + versionText) : '');
      var wrap = document.querySelector('.bundle-custom-text[data-group="' + group + '"][data-place="' + place + '"]');
      if (wrap) {
        var input = wrap.querySelector('input');
        if (input && input.value.trim() !== '' && (code === '39' || code === '42' || code === '43')) {
          props[baseName] = mainText + ': ' + input.value.trim();
        }
      }
    });
    return props;
  }
  function removeOldLines() {
    // Egyetlen ATOMI /cart/update.js hívással törlünk minden páros hoodie sort.
    // A change.js-t egyenként hívva a második kulcs elavulhat (a kosár közben változik),
    // ezért nem törölt. Az update.js egyszerre, egy kérésben állít 0-t minden megadott
    // kulcshoz, így nincs elavult kulcs és nincs versenyhelyzet.
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p['Pár hoodie']) updates[it.key] = 0;
        });
        try { window.__sinnersDebug = 'Talált páros sor: ' + Object.keys(updates).length; } catch (e) {}
        if (!Object.keys(updates).length) return Promise.resolve();
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      });
  }
  function cleanUrl() {
    try {
      var clean = window.location.pathname;
      window.history.replaceState({}, document.title, clean);
    } catch (e) {}
  }
  function run() {
    var toggle = document.getElementById('bundle-toggle');
    var designer = document.getElementById('bundle-designer');
    if (designer && (designer.style.display === 'none' || designer.style.display === '')) {
      if (toggle) toggle.click();
    }
    setTimeout(function () {
      prefillGroup('a', payload.a);
      prefillGroup('b', payload.b);
      prefillNote();
      hookReplaceOnAdd();
      cleanUrl();
      var card = document.getElementById('couple-bundle-card');
      if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      showEditBanner();
    }, 400);
  }
  function showEditBanner() {
    var card = document.getElementById('couple-bundle-card');
    if (!card) return;
    if (document.getElementById('sinners-edit-banner')) return;
    var b = document.createElement('div');
    b.id = 'sinners-edit-banner';
    b.textContent = 'Szerkesztési mód: módosítsd a párost, majd tedd a kosárba – a korábbi verzió automatikusan lecserélődik. Ha mégse szeretnéd, csak lépj vissza, a kosarad érintetlen marad.';
    b.style.cssText = 'margin:0 0 14px;padding:10px 14px;border-radius:10px;background:#1d3a1d;color:#c9f5c9;font-size:.85rem;border:1px solid #2e5e2e;';
    card.insertBefore(b, card.firstChild);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
